import App from "./App";
import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import 'antd/dist/reset.css';
import "@fortawesome/free-solid-svg-icons";
import "@fortawesome/react-fontawesome";
import "./i18n";
import { unstable_batchedUpdates } from "react-dom";
import "./init";

unstable_batchedUpdates(() => {
  console.error = () => {};
});

class ErrorBoundary extends React.Component {
  componentDidCatch(error, info) {
    if (error.message.includes("ToastContainer")) {
      // Suppress the warning related to ToastContainer
      return;
    }
    // Log or handle other errors
    console.log("error: ", error, info);
  }

  render() {
    return this.props.children;
  }
}

const rootElement = document.getElementById("root");

const root = ReactDOM.createRoot(rootElement);

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
